import React from 'react'
import '../../css/Main/Hero.css'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { FaArrowRight } from "react-icons/fa";

const Hero = () => {
  const navigate=useNavigate();
  return (
    <div className='hero-container' style={{
    backgroundImage: "url('/uploads/herobackground.png')",
  }}>
        <div className='hero-content'>
            <h1>Saremco Tömőanyagok!</h1>
            <p>A SAREMCO Dental AG tömőanyagai svájci fejlesztésű, biokompatibilis kompozitok, amelyek kiváló esztétikát és tartósságot biztosítanak a fogászati restaurációk során. Különlegességük, hogy több termékük HEMA- és TEGDMA-mentes, így érzékenyebb páciensek számára is kedvező választást jelenthetnek.</p>
            <div className='hero-call'>
              <FaArrowRight onClick={() => navigate('/rolunk')}/>
            </div>
        </div>
    </div>
  )
}

export default Hero